import React from 'react';
import EntityIcon from '../../../../components/EntityIcon/EntityIcon';
import {Box, Span, Text, ResultSubject, PreviewContainer} from '../../../../styled';
import HighlightMarker from '../../../../components/HighlightMarker/HighlightMarker';
import FileAttachments from '../../../../components/FileAttachments/FileAttachments';
import styled from 'styled-components';

const TeamsMessageContainer = styled(Box)`
  padding: 5px;
  display: flex;
  white-space: normal;
  &.Matched{
    background: radial-gradient(100% 100% at 0% 0%, rgba(221, 227, 250, 0.99) 0%, rgba(221, 229, 250, 0.4) 100%);
    margin-left: -5px;
    border-radius: 10px;
    padding-left: 10px;
    padding-right: 10px;
  }
  & p{
    margin-top: 0.5rem;
    margin-bottom: 0.5rem;
  }
`

const TeamsMessageItem = ({ message, isMatch }:any) => (
  <TeamsMessageContainer className={isMatch ? 'Matched' : ''}>
    <Box maxWidth={170} width="30%" mr={25} mb={0}>
      <Text fontSize={20} color="darkViolet">
        {message.sender || ''}
      </Text>
    </Box>
    <Box
      display="flex"
      flexDirection="column"
      maxWidth="100%"
    >
      <HighlightMarker>
        <Text fontSize={20} color="darkViolet">
          {message.resultText}
        </Text>
      </HighlightMarker>
      <FileAttachments files={message.att} />
    </Box>
  </TeamsMessageContainer>
)


const TeamsPreview = ({ item }: any) => {
  return (
    <Box display="flex" flexDirection="column" overflow="hidden" width="100%">
      <Box display="flex" alignItems="center">
        <Box mr={20}>
          <EntityIcon entityName={item.pl} />
        </Box>
        <Box>
          <ResultSubject>
            <Span>From: </Span>
            <HighlightMarker>{item.sender}</HighlightMarker>
          </ResultSubject>
          <Text>
            {`${item.teamDisplayName} ${item.channelDisplayName ? `| #${item.channelDisplayName}` : ''}`}
          </Text>
        </Box>
      </Box>
      <PreviewContainer ml={[0, 60]}>
        {item.conversation.map((reply:any) => (
          <TeamsMessageItem
            key={reply.reply_msg_id}
            message={reply}
            isMatch={reply.isMatch}
          />
        ))}
      </PreviewContainer>
    </Box>
  )
}

export default TeamsPreview;